import { LoanappService } from './../../services/loanapp.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
  selector: 'app-cma-report',
  templateUrl: './cma-report.component.html',
  styleUrls: ['./cma-report.component.css'],
})
export class CmaReportComponent implements OnInit {
  appId: String;
  uId: String;
  appdetails: any;

  constructor(
    private lservice: LoanappService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.appId = params['id'];
      this.uId = params['uId'];
    });
  }

  ngOnInit() {
    this.getData();
  }

  getData() {
    this.lservice.getLoanAppDetailsCMA(this.appId).subscribe(
      (data) => {
        if (data['success']) {
          this.appdetails = data['lapp'];
        } else {
          this.toastr.error('Something went wrong. Please try again!');
        }
      },
      (err) => {
        console.log(err, 'ERROR');
        this.toastr.error('Error occurred. Please try again');
        $('#error').modal('show');
      }
    );
  }

  okbtn() {
    window.location.href =
      '/loanapplicationdetails?id=' + this.appId + '&uId=' + this.uId;
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }
}
